
const digest = '9d8278babb9fb1b8ae4d2cef51e50e231f6344d1ef882abd2b4d2a805449fd1b';
const classes = {"warning":"_warning_x1wlv_1","warningBold":"_warningBold_x1wlv_10","patientsTime":"_patientsTime_x1wlv_14","plannedIn":"_plannedIn_x1wlv_21"};
const css = `._warning_x1wlv_1 {
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  font-weight: 500;
  margin: 20px 0;
  color: #d81616;
  border-radius: 15px;
}

._warningBold_x1wlv_10 {
  font-weight: 600;
}

._patientsTime_x1wlv_14 {
  font-family: "Rubik", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #d81616;
}

._plannedIn_x1wlv_21 {
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 20px;
  letter-spacing: 0;
  color: rgb(22, 101, 216);
  font-family: Rubik;
  background: rgba(22, 101, 216, 0.1);
  width: fit-content;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  